export default "__VITE_ASSET__950a16c8__"